import dao from '../../common/DataAccessUtil';
import configurationService from '../core/configuration.service';
import { ITagItem } from './tag.service.js';
const ControllerName = 'Pages';

export interface IPageItem {
  Id: number;
  ParentId: number | any;
  Name: string;
  Title: string;
  Body: string;
  PageOrder: number;
  PageUrl: string;
  StartDate: any;
  EndDate: any;
}

export default {
  search: async (title: string, pageNumber: number, pageSize: number) => {
    const body = { Filter: title, Sort: 'OrderNo asc', PageNumber: pageNumber, PageSize: pageSize };
    return dao.postJsonData(configurationService.getApiConfig(), ControllerName + '/search', body);
  },
  getAll: async () => {
    return dao.getJsonData(configurationService.getApiConfig(), ControllerName + '/getall');
  },
  getById: async (itemId: number) => {
    return dao.getJsonData(configurationService.getApiConfig(), ControllerName + '/' + itemId);
  },
  create: async (
    parentId: number,
    title: string,
    name: string,
    pageBody: string,
    pageOrder: number,
    pageUrl: string,
    tags: ITagItem[],
    fileIds: number[],
    startDate: any,
    endDate: any,
  ) => {
    const body = {
      ParentId: parentId > 0 ? parentId : null,
      Name: name,
      Title: title,
      Body: pageBody,
      PageOrder: pageOrder,
      PageUrl: pageUrl,
      Tags: tags,
      FileIds: fileIds,
      StartDate: startDate,
      EndDate: endDate,
    };
    return dao.postJsonData(configurationService.getApiConfig(), ControllerName, body);
  },

  update: async (
    itemId: any,
    parentId: any,
    title: string,
    name: string,
    pageBody: string,
    pageOrder: number,
    pageUrl: any,
    tags: ITagItem[],
    fileIds: number[],
    startDate: any,
    endDate: any,
  ) => {
    const body = {
      Id: itemId,
      ParentId: parentId > 0 ? parentId : null,
      Name: name,
      Title: title,
      Body: pageBody,
      PageOrder: pageOrder,
      PageUrl: pageUrl,
      Tags: tags,
      FileIds: fileIds,
      StartDate: startDate,
      EndDate: endDate,
    };
    return dao.postJsonData(configurationService.getApiConfig(), ControllerName + '/update', body);
  },

  delete: async (id: number) => {
    return dao.postJsonData(configurationService.getApiConfig(), ControllerName + '/delete', { Id: id });
  },
};
